import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsLeadershipManagementEnabled = () => boolean;
export const useIsLeadershipManagementEnabled: UseIsLeadershipManagementEnabled = () => {
  const isVivaEngagePremiumTreatmentEnabled = useExperimentTreatmentWithoutReporting('VivaEngagePremium') === true;

  return isVivaEngagePremiumTreatmentEnabled;
};
